import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import { WarningButton, BaseButton } from 'components/button'
import Modalizer from 'components/modalizer/modalizer'
import themeTypes from 'helpers/enums/themes/themeTypes'

import styles from './confirm.scss'
import getThemeClassResolver from 'helpers/themes/themeClassResolver'

const renderCancelButton = (theme, action, btn) => {
	const themeProps = {
		[themeTypes.LIGHT]: {
			bgColor: 'border-gray',
		},
		[themeTypes.DARK]: {
			bgColor: 'black-border-white',
			fontColor: 'white',
		},
	}
	return <BaseButton
		{...themeProps[theme]}
		onClick={action}
		autoFocus={true}
		focus={true}
		tabIndex={100}
		onTouchEnd={e => {
			e.preventDefault()
			action()
		}}
	>
		{btn}
	</BaseButton>
}

const renderConfirmButton = (theme, action, btn) => {
	const themeProps = {
		[themeTypes.LIGHT]: {
			bgColor: 'blue',
			fontColor: 'white',
		},
		[themeTypes.DARK]: {
			bgColor: 'black-border-blue',
			fontColor: 'white',
		},
	}
	return <BaseButton
		{...themeProps[theme]}
		onClick={action}
		focus={true}
		tabIndex={101}
		onTouchEnd={e => {
			e.preventDefault()
			action()
		}}
	>
		{btn}
	</BaseButton>
}

const Confirm = props => (
	<Modalizer
		closeAction={props.closeAction}
		closeButton={props.closeButton}
		theme={props.theme}
		isTopLayer={props.isTopLayer}
	>
		<div styleName={classNames({
			container: true,
			'container--single-action': !(props.btOne && props.btTwo),
			...getThemeClassResolver([themeTypes.DARK, themeTypes.LIGHT], 'container--', props.theme),
		})}>
			{props.alertTitle &&
				<SecondaryTitle
					icon={props.alertIcon}
					isCentered={props.centeredTitle}
					theme={props.theme}
				>
					{props.alertTitle}
				</SecondaryTitle>
			}
			<p styleName={classNames({
				subtitle: true,
				'subtitle--centered': props.centeredMessage,
			})}>
				{props.alertMessage}
			</p>
			<div styleName={classNames({
				'btn-bar': true,
				'single-button': !(props.btOne && props.btTwo),
			})}>
				{props.btOne &&
					<div styleName='btn-bar_button'>
						{renderCancelButton(props.theme, props.actionOne, props.btOne)}
					</div>
				}
				<div styleName='btn-bar_button'>
					{props.actionButtonType === 0 &&
						renderConfirmButton(props.theme, props.actionTwo, props.btTwo)
					}
					{props.actionButtonType === 1 &&
						<WarningButton
							focus={true}
							tabIndex={101}
							onTouchEnd={e => {
								e.preventDefault()
								props.actionTwo()
							}}
							onClick={props.actionTwo}>{props.btTwo}
						</WarningButton>
					}
				</div>
			</div>
			{props.checkbox}
		</div>
	</Modalizer>
)

Confirm.defaultProps = {
	alertIcon: null,
	alertMessage: 'Default Message',
	actionButtonType: 0,
	centeredTitle: false,
	centeredMessage: false,
	closeButton: true,
	isTopLayer: true,
	checkbox: null,
	theme: themeTypes.LIGHT,
}

Confirm.propTypes = {
	closeAction: PropTypes.func,
	alertTitle: PropTypes.string,
	alertIcon: PropTypes.node,
	alertMessage: PropTypes.string,
	actionButtonType: PropTypes.number,
	actionOne: PropTypes.func,
	btOne: PropTypes.string,
	actionTwo: PropTypes.func,
	btTwo: PropTypes.string,
	centeredTitle: PropTypes.bool,
	closeButton: PropTypes.bool,
	isTopLayer: PropTypes.bool,
	checkbox: PropTypes.object,
	theme: PropTypes.oneOf([themeTypes.LIGHT, themeTypes.DARK]),
	centeredMessage: PropTypes.bool,
}

export default CSSModules(Confirm, styles, {allowMultiple: true})
